import type { OrderItem } from "@@/shared/orders/order-items/order-item";
import type { OrderChange } from "./_order-change";

const orderChangeHasOrderItemCheck = <T extends OrderChange>(
    change: T,
): change is T & { data: T["data"] & { orderItem: OrderItem } } => {
    return "orderItem" in change.data;
};

export { orderChangeHasOrderItemCheck };
